<template>
  <div class="px-3 lg:px-5">
    <!-- <router-link :to="{ name: 'Dashboard' }" class="w-16 text-left flex flex-row items-center ">
      <button v-if="ownership" class="text-cyan-700 hover:text-gray-600">Dahboard</button>
    </router-link> -->
    <div class="error" v-if="error">{{ error }}</div>
    <div v-if="todolist">
      <div class="flex flex-wrap pt-11 lg:pt-16 mt-5">
        <div class="w-full lg:w-1/4 ">
          <div class="text-center md:text-left rounded-lg bg-gray-900 p-3 ">
            <h2 class="text-cyan-700 text-lg">{{ todolist.title }}</h2>
            <p>author Mr / Ms {{ todolist.userName }}</p>
            <span class=" flex border-2 border-dashed border-gray-700 mb-4"></span>
            <p class="text-gray-400">{{ todolist.body }}</p>
            <button v-if="ownership" @click="handleDelete" class="text-gray-400 hover:text-cyan-700 mt-5 ">Delete todolist</button>
          </div>
        </div>
        <div class="w-full lg:w-3/4 lg:px-4 ml-auto">
          <div class="pt-4 lg:pt-0 lg:text-left space-y-3">
            <div class="ml-auto rounded-lg ">
              <div v-if="!todolist.checklists.length" class="text-center">No todolist have been added to this list yet.</div>
              <div v-for="checklist in todolist.checklists" :key="checklist.id" class="pb-4 ">
                <div class=" bg-white dark:bg-gray-800 rounded-lg p-4 ">
                  <p class="italic text-cyan-700">#{{ checklist.title }}</p>
                  <span>
                    <p class="text-gray-600 dark:text-gray-400">{{ checklist.detail }}</p>
                    <button v-if="ownership" @click="handleClick(checklist.id)" class="bg-transparent text-dusty-gray text-sm lg:ml-auto ">delete</button>
                  </span>
                </div>
              </div>
            </div>

            <AddList v-if="ownership" :todolist="todolist" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddList from "@/components/todolist/AddList.vue"

import useDocument from "@/composables/useDocument"
import getDocument from "@/composables/getDocument"
import getUser from "@/composables/getUser"
import { computed } from "vue"
import { useRouter } from "vue-router"
export default {
  props: ["id"],
  components: { AddList },
  setup(props) {
    const { error, document: todolist } = getDocument("todolists", props.id)
    const { user } = getUser()
    const { deleteDoc, updateDoc } = useDocument("todolists", props.id)

    const router = useRouter()
    const ownership = computed(() => {
      return todolist.value && user.value && user.value.uid == todolist.value.userId
    })
    const handleDelete = async () => {
      await deleteDoc()

      router.push({ name: "UserTodolists" })
    }
    const handleClick = async (id) => {
      const checklists = todolist.value.checklists.filter((checklists) => checklists.id != id)
      await updateDoc({ checklists })
    }
    return { error, todolist, ownership, handleDelete, handleClick }
  },
}
</script>

<style></style>
